export const personnelTransferRouter = [
  {
    path: "/staff-manage/personnel-transfer/list",
    name: "personnel-transfer-list",
    meta: { title: "人事调动" },
    component: () => import(/* webpackChunkName: "personnel-transfer-list" */ "@/views/staff-manage/personnel-transfer/list/index.vue"),
  },
  {
    path: "/staff-manage/personnel-transfer/add",
    name: "personnel-transfer-add",
    hidden: true,
    meta: { title: "新增人事调动", comName: "StaffManagePersonnelTransferFormCreate"  },
    component: () =>
      import(/* webpackChunkName: "personnel-transfer-add" */ "@/views/staff-manage/personnel-transfer/form-create/index.vue"),
  },
  {
    path: "/staff-manage/personnel-transfer/edit/:id",
    name: "personnel-transfer-eidt",
    hidden: true,
    meta: { title: "编辑人事调动", comName: "StaffManagePersonnelTransferFormCreate"  },
    component: () =>
      import(/* webpackChunkName: "personnel-transfer-edit" */ "@/views/staff-manage/personnel-transfer/form-create/index.vue"),
  },
  {
    path: "/staff-manage/personnel-transfer/detail/:id",
    name: "personnel-transfer-detail",
    hidden: true,
    meta: { title: "人事调动详情" },
    component: () =>
      import(/* webpackChunkName: "personnel-transfer-detail" */ "@/views/staff-manage/personnel-transfer/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/staff-manage/personnel-transfer/flowPrint/:id",
    name: "personnel-transfer-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/personnel-transfer/flow-print/index.vue"
      ),
  },
]
